export function LogoMark({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="16" cy="16" r="13" stroke="currentColor" strokeWidth="2.4" opacity="0.9" />
      <rect x="9.5" y="15" width="3" height="7.5" rx="1.5" fill="currentColor" />
      <rect x="14.5" y="9.5" width="3" height="13" rx="1.5" fill="currentColor" />
      <rect x="19.5" y="12.5" width="3" height="10" rx="1.5" fill="currentColor" />
    </svg>
  );
}

export default function Logo({
  textClassName = "text-slate-900",
  markClassName = "text-white",
  badgeClassName = "bg-emerald-500",
  tagline = false,
  size = "md",
}) {
  const badge = size === "sm" ? "w-8 h-8" : "w-9 h-9";
  const mark = size === "sm" ? "w-4 h-4" : "w-5 h-5";
  const word = size === "sm" ? "text-lg" : "text-xl";
  return (
    <span className="flex items-center gap-2">
      <span className={`${badge} rounded-xl flex items-center justify-center ${badgeClassName}`}>
        <LogoMark className={`${mark} ${markClassName}`} />
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-display font-extrabold ${word} tracking-tight ${textClassName}`}>HARMONEYS</span>
        {tagline && <span className={`text-[10px] tracking-[0.16em] uppercase font-semibold mt-0.5 ${textClassName} opacity-60`}>Enjoy The Difference</span>}
      </span>
    </span>
  );
}
